import { Component, Inject } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatterFileType } from '@models/matter';
import {
	StatementOfAccountDefault,
	StatementOfAccountType,
} from '@models/statementOfAccount';
import { BusinessStatementOfAccountsDefaultRepoService } from '@repos/business-statement-of-account-defaults/businessStatementOfAccountsDefaultRepo';
import { createId } from '@core/util/file';
import { ICON } from '@core/util/icon';

export interface AddStatementOfAccountDefaultData {
	type: StatementOfAccountType;
	index: number;
	matterType: MatterFileType;
}
@Component({
	selector: 'app-add',
	templateUrl: './add.component.html',
	standalone: false,
})
export class AddStatementOfAccountDefaultComponent {
	public description: string;
	public price: number;
	public type: StatementOfAccountType;
	public index: number;
	public submitted = false;
	public fileType: MatterFileType;
	public ICON = ICON;

	constructor(
		public dialogRef: MatDialogRef<AddStatementOfAccountDefaultComponent>,
		@Inject(MAT_DIALOG_DATA) public data: AddStatementOfAccountDefaultData,
		private repo: BusinessStatementOfAccountsDefaultRepoService,
	) {
		this.type = data.type;
		this.index = data.index;
		this.fileType = data.matterType;
	}

	async add(form: NgForm) {
		this.submitted = true;

		if (form.valid) {
			const data: StatementOfAccountDefault = {
				id: createId(),
				type: this.type,
				containsDocumentText: this.type === StatementOfAccountType.FEE,
				description: this.description,
				price: this.price,
				deletable: true,
				fileType: this.fileType,
				index: this.index,
				defaultType: null,
			};
			await this.repo.Create(data);
			this.dialogRef.close();
		}
	}
}
